// Models
import { DistrictViewModel } from '../models/district-view.model';

export namespace DistrictActions {
	export class GetAll {
		static readonly type = '[District] Get Districts';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[District] Set Districts';
		constructor(public districts: DistrictViewModel[]) {}
	}
}
